import React from 'react';
import { DiagnosticTool } from '../components/DiagnosticTool';

export const Diagnostic: React.FC = () => {
  return (
    <div style={{ paddingTop: '80px' }}>
      {/* Header */}
      <section
        style={{
          paddingTop: '64px',
          paddingBottom: '60px',
          borderBottom: '1px solid var(--border-subtle)',
          background: 'radial-gradient(ellipse 70% 50% at 50% 0%, var(--brand-red-glow-subtle), transparent)',
        }}
      >
        <div className="container-max" style={{ textAlign: 'center', maxWidth: '820px' }}>
          <span className="badge-pill badge-red" style={{ marginBottom: '16px' }}>
            FINANCIAL INTELLIGENCE CHECK
          </span>
          <h1
            style={{
              fontSize: 'clamp(2.5rem, 5vw, 3.8rem)',
              fontWeight: 800,
              color: 'var(--text-primary)',
              letterSpacing: '-0.02em',
              marginBottom: '20px',
            }}
          >
            12-Point Diagnostic Checklist
          </h1>
          <p style={{ fontSize: '1.2rem', color: 'var(--text-primary)', marginBottom: '12px', fontWeight: 500 }}>
            This diagnostic identifies the gap — and shows you exactly where you stand.
          </p>
          <p
            className="font-serif"
            style={{
              fontSize: '1.45rem',
              fontStyle: 'italic',
              color: 'var(--brand-red-light)',
            }}
          >
            Accounting tells you what happened. Intelligence tells you what to do next.
          </p>
        </div>
      </section>

      {/* Interactive Tool Section */}
      <section style={{ padding: '64px 0 96px 0' }}>
        <div className="container-max" style={{ maxWidth: '1080px' }}>
          <DiagnosticTool />

          {/* Three Stage Breakdown Explanation */}
          <div style={{ marginTop: '64px' }}>
            <h3
              style={{
                fontSize: '1.4rem',
                fontWeight: 700,
                color: 'var(--text-primary)',
                marginBottom: '24px',
                textAlign: 'center',
              }}
            >
              How Scores Are Interpreted
            </h3>

            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                gap: '20px',
              }}
            >
              <div
                className="glass-panel"
                style={{
                  padding: '28px',
                  borderTop: '3px solid #ff5252',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
                  <h4 style={{ fontSize: '1.15rem', fontWeight: 700, color: 'var(--text-primary)' }}>
                    Foundation Stage
                  </h4>
                  <span className="font-mono badge-pill badge-red" style={{ fontSize: '0.75rem' }}>
                    0–4 Points
                  </span>
                </div>
                <p style={{ fontSize: '0.9rem', color: 'var(--text-secondary)', lineHeight: '1.6' }}>
                  Significant gaps exist in your financial intelligence and decision-support capabilities. Your business operates predominantly on historical recording rather than proactive steering.
                </p>
              </div>

              <div
                className="glass-panel"
                style={{
                  padding: '28px',
                  borderTop: '3px solid var(--signal-amber)',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
                  <h4 style={{ fontSize: '1.15rem', fontWeight: 700, color: 'var(--text-primary)' }}>
                    Development Stage
                  </h4>
                  <span className="font-mono badge-pill" style={{ background: 'rgba(255, 179, 0, 0.12)', color: 'var(--signal-amber)', border: '1px solid rgba(255, 179, 0, 0.3)', fontSize: '0.75rem' }}>
                    5–8 Points
                  </span>
                </div>
                <p style={{ fontSize: '0.9rem', color: 'var(--text-secondary)', lineHeight: '1.6' }}>
                  You have some intelligence capabilities, but gaps remain. Strategic improvements in cash runway, unit economics, and automation will unlock faster, more confident decisions.
                </p>
              </div>

              <div
                className="glass-panel"
                style={{
                  padding: '28px',
                  borderTop: '3px solid var(--signal-green)',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
                  <h4 style={{ fontSize: '1.15rem', fontWeight: 700, color: 'var(--text-primary)' }}>
                    Intelligence Stage
                  </h4>
                  <span className="font-mono badge-pill badge-green" style={{ fontSize: '0.75rem' }}>
                    9–12 Points
                  </span>
                </div>
                <p style={{ fontSize: '0.9rem', color: 'var(--text-secondary)', lineHeight: '1.6' }}>
                  You're operating at a high level. Finance is a strategic asset. Minor optimizations with Forty2's automated platform will refine your competitive edge further.
                </p>
              </div>
            </div>
          </div>

          {/* Bottom Philosophy Banner */}
          <div
            className="glass-panel"
            style={{
              marginTop: '48px',
              padding: '36px',
              textAlign: 'center',
              backgroundColor: 'var(--bg-card)',
            }}
          >
            <p
              className="font-serif"
              style={{
                fontSize: 'clamp(1.2rem, 2.5vw, 1.6rem)',
                fontStyle: 'italic',
                color: 'var(--text-primary)',
                lineHeight: '1.5',
              }}
            >
              Financial intelligence is not just about reports. It is about building businesses that are predictable, scalable, and sustainable.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};
